module.exports = __webpack_public_path__ + "static/media/disagree-white.c098b181.svg";